import React, { useState, useContext, useEffect } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { makeStyles, Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { EditingMessageContext } from "../../context/EditingMessage/EditingMessageContext";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(() => ({
  reactionMenuItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 6,
    cursor: "default",
  },
  reactionLabel: {
    fontSize: 14,
  },
  reactionEmojis: {
    display: "flex",
    gap: 6,
  },
  reactionEmojiButton: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: 18,
    padding: 0,
    lineHeight: 1,
  },
  reactionMoreButton: {
    marginTop: 4,
    fontSize: 12,
    color: "#666",
    cursor: "pointer",
  },
  reactionPicker: {
    marginTop: 6,
  },
}));

const MessageOptionsMenu = ({ message, menuOpen, handleClose, anchorEl }) => {
  const classes = useStyles();
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const { setEditingMessage } = useContext(EditingMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const reactionEmojis = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

  useEffect(() => {
    if (!menuOpen) {
      setShowEmojiPicker(false);
    }
  }, [menuOpen]);

  const canReact =
    !message?.isDeleted &&
    !String(message?.mediaType || "")
      .toLowerCase()
      .includes("reaction");

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    setEditingMessage(null);
    handleClose();
  };

  const handleEditMessage = () => {
    setReplyingMessage(null);
    setEditingMessage(message);
    handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  const handleReactMessage = async (emoji) => {
    try {
      await api.post(`/messages/${message.id}/reactions`, {
        reaction: emoji,
      });
    } catch (err) {
      toastError(err);
    } finally {
      handleClose();
      setShowEmojiPicker(false);
    }
  };

  const handleToggleEmojiPicker = (event) => {
    event.stopPropagation();
    setShowEmojiPicker((prevState) => !prevState);
  };
  return (
    <>
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {message?.canEdit && (
          <MenuItem onClick={handleEditMessage}>
            {i18n.t("messageOptionsMenu.edit")}
          </MenuItem>
        )}
        {message.fromMe && (
          <MenuItem onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        {canReact && (
          <MenuItem className={classes.reactionMenuItem} disableRipple>
            <span className={classes.reactionLabel}>
              {i18n.t("messageOptionsMenu.react")}
            </span>
            <div className={classes.reactionEmojis}>
              {reactionEmojis.map((emoji) => (
                <button
                  key={emoji}
                  type="button"
                  className={classes.reactionEmojiButton}
                  onClick={() => handleReactMessage(emoji)}
                  aria-label={emoji}
                >
                  {emoji}
                </button>
              ))}
            </div>
            <button
              type="button"
              className={classes.reactionMoreButton}
              onClick={handleToggleEmojiPicker}
            >
              {i18n.t("messageOptionsMenu.moreEmojis")}
            </button>
            {showEmojiPicker && (
              <div className={classes.reactionPicker}>
                <Picker
                  onSelect={(emoji) => handleReactMessage(emoji.native)}
                  showPreview={false}
                  showSkinTones={false}
                  title=""
                />
              </div>
            )}
          </MenuItem>
        )}
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;
